import UploaderIdentityDocuments from "@/components/UploaderIdentityDocuments";

export default {
  name: "identity_documents",

  data() {
    return {
      submitLoading: false,
      dropzoneOptions: {
        url: process.env.VUE_APP_API,
        thumbnailWidth: 106,
        thumbnailHeight: 80,
        maxFilesize: 10,
        maxFiles: 10,
        acceptedFiles: "image/*,application/pdf",
        headers: {
          authorization: `Bearer ${localStorage.getItem("AUTH_TOKEN")}`
        },
        dictDefaultMessage: "Choose a file to upload",
        addRemoveLinks: true,
        paramName: "variables[file]"
      },
      isDestroying: false
    };
  },

  computed: {
    currentUser() {
      return this.$store.state.user;
    }
  },

  methods: {},

  components: {
    UploaderIdentityDocuments
  }
};
